// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eab0352a","667":"da8aa047","977":"3becd578"}[chunkId] + ".chunk.js";
};